<template>
  <div :class="sidebarClasses">
    <div class="sidebar-wrapper">
      <div class="logo">
        <span class="simple-text">
          <img class="logo-img" :src="require('../../assets/appicons/logo.svg')" alt="Budget Vals">
        </span>
      </div>
      <slot>
      </slot>
      <ul :class="navClasses" v-if="$user.loggedIn">
        <li class="nav-item" v-for="(link,index) in sidebarLinks" :key="link.name + index" @click="toggleSidebar">
          <router-link class="nav-link" :to="link.path" :ref="link.name">
            <p>
              <img
                class="nav-item-img"
                :src="link.img ? `https://s3-ap-southeast-2.amazonaws.com/budgetvals/data/${(link.isActive && link.activeImg ? link.activeImg : link.img)}` : require('../../assets/appicons/placeholder.jpg')"
                alt="Menu Logo" />
              <span>{{ link.name }} 
                <span v-if="link.name == 'Awaiting Customers' && pendingClientCount !== 0" class="txt">{{ pendingClientCount }}</span>
                <span v-if="link.name == 'Approved Quotes' && pendingApprovedQuotesCount !== 0" class="txt">{{ pendingApprovedQuotesCount }}</span>
                <span v-if="link.name == 'Manual Quote Requests' && pendingManualQuotesCount !== 0" class="txt">{{ pendingManualQuotesCount }}</span>
                <span v-if="link.name == 'Price Guarantee Requests' && pendingPBGCount !== 0" class="txt">{{ pendingPBGCount }}</span>
              </span>
              
            </p>
          </router-link>
        </li>
      </ul>
      <!-- <moving-arrow v-if="$user.loggedIn" :move-y="arrowMovePx"></moving-arrow> -->
      
    </div>
  </div>
</template>
<style scoped>
.txt {
  background-color:red;
  font-size:xx-small;
  position: relative;
  padding:2px;
  border-radius: 50px;
}
</style>

<script>
  import { mapGetters } from 'vuex'
  import {
    ACTIVE_LINK,
    LOAD_SIDEBAR,
    LOAD_PENDING_CLIENT_COUNT,
    LOAD_PENDING_APPROVED_QUOTES_COUNT,
    LOAD_PENDING_MANUAL_QUOTES_COUNT,
    LOAD_PENDING_PBG_COUNT
  } from '@/vuex/types'
  import MovingArrow from './MovingArrow.vue'
  export default {
    name: 'SideBar',
    props: {
      type: {
        type: String,
        default: 'sidebar'
      },
      sidebarLinks: {
        type: Array,
        default: []
      },
      showSidebar: {
        type: Boolean,
        default: false
      }
    },
    components: {
      MovingArrow
    },
    computed: {
      ...mapGetters([
        '$sidebar',
        'pendingClientCount',
        'pendingApprovedQuotesCount',
        'pendingManualQuotesCount',
        'pendingPBGCount'
      ]),
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav flex-column'
        } else {
          return 'nav navbar-nav'
        }
      },
      arrowMovePx () {
        return this.linkHeight * this.activeLinkIndex
      }
    },
    data () {
      return {
        linkHeight: 44,
        activeLinkIndex: 0,
        windowWidth: 0,
        hasAutoHeight: false
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$store.commit('displaySidebar', false)
        }
      },
      findActiveLink () {
        this.sidebarLinks.find((element, index) => {
          let found = this.$route.path.includes(element.path)
          if (found) {
            this.activeLinkIndex = index
            element.isActive = true
            this.$store.commit(ACTIVE_LINK, element)
          } else {
            element.isActive = false
          }
          return found
        })
      }
    },
    async mounted () {
      await this.$store.dispatch(LOAD_SIDEBAR)
      if (this.$user.administrator) {
        await this.$store.dispatch(LOAD_PENDING_CLIENT_COUNT)
        await this.$store.dispatch(LOAD_PENDING_APPROVED_QUOTES_COUNT)
        await this.$store.dispatch(LOAD_PENDING_MANUAL_QUOTES_COUNT)
        await this.$store.dispatch(LOAD_PENDING_PBG_COUNT)
      }
      this.findActiveLink()
    },
    watch: {
      $route: async function (newRoute, oldRoute) {
        await this.$store.dispatch(LOAD_SIDEBAR)
        if (this.$user.administrator) {
          await this.$store.dispatch(LOAD_PENDING_CLIENT_COUNT)
          await this.$store.dispatch(LOAD_PENDING_APPROVED_QUOTES_COUNT)
          await this.$store.dispatch(LOAD_PENDING_MANUAL_QUOTES_COUNT)
          await this.$store.dispatch(LOAD_PENDING_PBG_COUNT)
        }
        this.findActiveLink()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/SideBar.vue